// Monochrome brand glyphs (chrome/white). currentColor driven.
const paths = {
  instagram: (
    <>
      <rect x="2.5" y="2.5" width="19" height="19" rx="5.2" fill="none" stroke="currentColor" strokeWidth="1.7" />
      <circle cx="12" cy="12" r="4.2" fill="none" stroke="currentColor" strokeWidth="1.7" />
      <circle cx="17.4" cy="6.6" r="1.15" fill="currentColor" />
    </>
  ),
  tiktok: (
    <path
      fill="currentColor"
      d="M16.6 2h-3v13.1a2.6 2.6 0 1 1-2.2-2.57V9.46a5.7 5.7 0 1 0 5.2 5.68V8.6a7.1 7.1 0 0 0 4.2 1.36V6.86a4.1 4.1 0 0 1-2.9-1.2A4.1 4.1 0 0 1 16.6 2Z"
    />
  ),
  youtube: (
    <>
      <rect x="2.2" y="5.4" width="19.6" height="13.2" rx="4" fill="none" stroke="currentColor" strokeWidth="1.7" />
      <path fill="currentColor" d="M10.2 8.9 15.4 12l-5.2 3.1z" />
    </>
  ),
  facebook: (
    <path
      fill="currentColor"
      d="M13.5 21v-8h2.3l.4-3h-2.7V8.1c0-.87.24-1.46 1.5-1.46H16.5V4a20 20 0 0 0-2.3-.12c-2.3 0-3.9 1.4-3.9 3.98V10H8v3h2.3v8z"
    />
  ),
  spotify: (
    <path
      fill="currentColor"
      d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm4.6 14.4a.75.75 0 0 1-1.03.25c-2.2-1.34-4.97-1.64-8.24-.9a.75.75 0 1 1-.33-1.46c3.58-.8 6.66-.45 9.13 1.06.35.22.46.68.24 1.03zm1.23-2.73a.94.94 0 0 1-1.29.31c-2.52-1.55-6.36-2-9.34-1.09a.94.94 0 1 1-.54-1.79c3.4-1.03 7.63-.53 10.53 1.25.44.27.58.85.31 1.29zm.11-2.85c-3.02-1.79-8-1.96-10.9-1.08a1.12 1.12 0 1 1-.65-2.15c3.33-1.01 8.84-.81 12.31 1.25a1.12 1.12 0 1 1-1.15 1.93z"
    />
  ),
  apple: (
    <path
      fill="currentColor"
      d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.48 2.94-1.52.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.09z"
    />
  ),
};

export default function BrandIcon({ name, size = 20, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      {paths[name] || null}
    </svg>
  );
}
